/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import "./plugins/jquery.form/jquery.form.js";
import "./plugins/owl-slider/owl.carousel.min.js";
import "./plugins/validate/jquery.validate.js";
import "friendly-challenge/widget";

function handleCaptchaValidation(form) {
  if (window.friendlyOk === true) {
    form.submit();
  } else {
    document.addEventListener('friendly-captcha-fired', (event) => {
      if ($(form).valid() && event.detail.success) {
        form.submit();
      }
    })
  }
}

window.friendlyOk = false;
window.friendlyCaptchaCallback = () => {
  window.friendlyOk = true;

  document.dispatchEvent(new CustomEvent('friendly-captcha-fired', {
    detail: {
      success: true,
    }
  }));
}


(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    //**************************************************************************************************
    // Kör script på startsidan.
    //**************************************************************************************************
    home: {
      init: function() {
        $(document).ready(function() {
          //Removes the last .seperator-holder
          // $(".hero-innehall-small-boxes")
          $(".hero-innehall-small-boxes").each(function() {
            $(this)
              .find(".seperator-holder")
              .last()
              .css("display", "none");
          });

          // Kampanjsektion
          $(".wp-video-shortcode").prop("muted", true);

          $(".unMute").click(function() {
            $("#muteSound").addClass("unMuted");
            $(".wp-video-shortcode").prop("muted", false);
          });
          $(".muteSound").click(function() {
            $("#muteSound").removeClass("unMuted");
            $(".wp-video-shortcode").prop("muted", true);
          });

          var body = $("body");
          var video = $(".wp-video");
          var overlayKiller = $("#overlayKiller");
          var kampanjDiv = $("#frontpageKampanjSektion");
          $("#closeKamp").click(function() {
            body.removeClass("kampanjActive");
            video.remove();
            kampanjDiv.fadeOut();
            overlayKiller.fadeOut();
            $.cookie("coromatic-kampanj", "accepted", {
              expires: 3,
              path: "/",
            });
          });
          //**********************************************************************************************
          // BILDSPEL
          //**********************************************************************************************
          var n = $("li.item").length;
          if (n > 1) {
            var true_false = true;
          } else {
            var true_false = false;
          }
          $("#sliderUlFrontpage").owlCarousel({
            loop: true_false,
            mouseDrag: false,
            touchDrag: false,
            nav: true,
            navText: "",
            autoplay: true,
            autoplayTimeout: 10000,
            smartSpeed: 800,
            autoplayHoverPause: false,
            dots: false,
            responsive: {
              0: {
                items: 1,
              },
              600: {
                items: 1,
              },
              1000: {
                items: 1,
              },
            },
          });
          if (true_false == false) {
            $(".loading-box").addClass("hidden");
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    search: {
      init: function() {
        $(document).ready(function() {
          var langPrefix = $("#langPrefix").val();
          if (langPrefix === "sv") {
            var showText = "Inga fler sökresultat finns att visa";
            var traff = "träff";
            var traffar = "träffar";
          } else if (langPrefix === "dk") {
            var showText = "Ikke flere resultater tilgængelige";

            var traff = "hit";
            var traffar = "hits";
          } else if (langPrefix === "fi") {
            var showText = "Ei enempää tuloksia osoittavat";

            var traff = "osumia";
            var traffar = "osumia";
          } else if (langPrefix === "en") {
            var showText = "No more search results are available";

            var traff = "hit";
            var traffar = "hits";
          }

          // Hämta och visa antalet resultat
          var allResults = $("#count_result_all").val();
          var allProductsResults = $("#count_result_products").val();
          // Hämtar olika text beroende på antalet
          if (allResults == 1) {
            var allResults = allResults + " " + traff;
          } else {
            var allResults = allResults + " " + traffar;
          }
          // Hämtar olika text beroende på antalet
          if (allProductsResults == 1) {
            var allProductsResults = allProductsResults + " " + traff;
          } else {
            var allProductsResults = allProductsResults + " " + traffar;
          }
          $(".countAllResults").text(allResults);
          $(".countProductsResults").text(allProductsResults);

          // Visa / Dölj de olika resultssektionerna
          $(".toggleResults").click(function() {
            var resultsID = $(this).attr("data-toggle");
            $(".resultContent").slideUp();
            $(".toggleResults").removeClass("active");
            $(this).addClass("active");

            if (
              $(".resultContent[data-results=" + resultsID + "]").is(":hidden")
            ) {
              $(".resultContent[data-results=" + resultsID + "]").slideDown(
                300
              );
            } else {
              $(".resultContent[data-results=" + resultsID + "]").slideUp(300);
            }
          });

          // Ladda fler Sökresultat
          searchResult = $("#search_result .search_post").size();
          j = 5;
          $("#search_result .search_post:lt(" + j + ")").show();

          if (searchResult <= j) {
            $("#loadMoreResults").addClass("disabled");
            $("#loadMoreResults").text(showText);
          }
          $("#loadMoreResults").click(function() {
            if (searchResult == j) {
              $("#loadMoreResults").addClass("disabled");
              $("#loadMoreResults").text(showText);
            } else {
              $("#loadMoreResults").addClass("loading");
              setTimeout(function() {
                j = j + 5 <= searchResult ? j + 5 : searchResult;
                $("#search_result .search_post:lt(" + j + ")").show();
                $("#loadMoreResults").removeClass("loading");
                if (searchResult <= j) {
                  $("#loadMoreResults").addClass("disabled");
                  $("#loadMoreResults").text(showText);
                }
              }, 1200);
            }
          });

          // Ladda fler Sökresultat för produkter
          searchResult = $("#search_result_products .search_post").size();
          j = 5;
          $("#search_result_products .search_post:lt(" + j + ")").show();

          if (searchResult <= j) {
            $("#loadMoreResultsProducts").addClass("disabled");
            $("#loadMoreResultsProducts").text(showText);
          }
          $("#loadMoreResultsProducts").click(function() {
            if (searchResult == j) {
              $("#loadMoreResultsProducts").addClass("disabled");
              $("#loadMoreResultsProducts").text(showText);
            } else {
              $("#loadMoreResultsProducts").addClass("loading");
              setTimeout(function() {
                j = j + 5 <= searchResult ? j + 5 : searchResult;
                $("#search_result_products .search_post:lt(" + j + ")").show();
                $("#loadMoreResultsProducts").removeClass("loading");
                if (searchResult <= j) {
                  $("#loadMoreResultsProducts").addClass("disabled");
                  $("#loadMoreResultsProducts").text(showText);
                }
              }, 1200);
            }
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    single_produkter: {
      init: function() {
        $(document).ready(function() {
          // Hantering av dokumentlistningen
          $("#toggleFirstDocList").click(function() {
            $(this).toggleClass("active");
            $("#firstDocList").slideToggle(300);
            $("#secoundDocList").slideUp(300);
            $("#toggleSecondDocList").removeClass("active");
          });

          $("#toggleSecondDocList").click(function() {
            $(this).toggleClass("active");
            $("#secoundDocList").slideToggle(300);
            $("#firstDocList").slideUp(300);
            $("#toggleFirstDocList").removeClass("active");
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    //**************************************************************************************************
    // Nyheter
    //**************************************************************************************************
    blog: {
      init: function() {
        $(document).ready(function() {
          //Om skärmen är Större eller lika med 961px
          if ($(window).width() > 961) {
            var langPrefix = $("#langPrefix").val();
            if (langPrefix === "sv") {
              var showText = "Inga fler nyheter finns att visa";
            } else if (langPrefix === "no") {
              var showText = "Ingen flere nyheter tilgjengelig for å vise";
            } else if (langPrefix === "dk") {
              var showText = "Ingen flere nyheder tilgængelige for at vise";
            } else if (langPrefix === "fi") {
              var showText = "NÄYTETTÄVÄT UUTISET LOPPUIVAT";
            } else if (langPrefix === "en") {
              var showText = "No more news available to display";
            }

            // Ladda fler nyheter
            const newsSize = $("#newsList .postRow").size();
            let n = 3;
            $("#newsList .postRow:lt(" + n + ")")
              .show()
              .css({
                display: "-webkit-flex",
                display: "-webkit-box",
                display: "-moz-box",
                display: "-ms-flexbox",
                display: "box",
                display: "flex",
              });

            if (newsSize <= n) {
              $("#loadMoreNews").addClass("disabled");
              $("#loadMoreNews").text(showText);
            }

            $("#loadMoreNews").click(function() {
              if (newsSize == n) {
                $("#loadMoreNews").addClass("disabled");
                $("#loadMoreNews").text(showText);
              } else {
                $("#loadMoreNews").addClass("loading");
                setTimeout(function() {
                  n = n + 3 <= newsSize ? n + 3 : newsSize;
                  $("#newsList .postRow:lt(" + n + ")")
                    .show()
                    .css({
                      display: "-webkit-flex",
                      display: "-webkit-box",
                      display: "-moz-box",
                      display: "-ms-flexbox",
                      display: "box",
                      display: "flex",
                    });
                  $("#loadMoreNews").removeClass("loading");
                  if (newsSize <= n) {
                    $("#loadMoreNews").addClass("disabled");
                    $("#loadMoreNews").text(showText);
                  }
                }, 1200);
              }
            });
          }

          //Om skärmen är Mindre eller lika med 961px
          if ($(window).width() < 961) {
            var langPrefix = $("#langPrefix").val();
            if (langPrefix === "sv") {
              var showText = "Inget mer att visa";
            } else if (langPrefix === "no") {
              var showText = "Ingenting mer å vise";
            } else if (langPrefix === "dk") {
              var showText = "Intet mere at vise";
            } else if (langPrefix === "fi") {
              var showText = "NÄYTETTÄVÄT UUTISET LOPPUIVAT";
            } else if (langPrefix === "en") {
              var showText = "Nothing more to show";
            }

            // Ladda fler nyheter
            newsSize = $("#newsList .postRow").size();
            n = 3;
            $("#newsList .postRow:lt(" + n + ")")
              .show()
              .css({ display: "block" });

            if (newsSize <= n) {
              $("#loadMoreNews").addClass("disabled");
              $("#loadMoreNews").text(showText);
            }

            $("#loadMoreNews").click(function() {
              if (newsSize == n) {
                $("#loadMoreNews").addClass("disabled");
                $("#loadMoreNews").text(showText);
              } else {
                $("#loadMoreNews").addClass("loading");
                setTimeout(function() {
                  n = n + 3 <= newsSize ? n + 3 : newsSize;
                  $("#newsList .postRow:lt(" + n + ")")
                    .show()
                    .css({ display: "block" });
                  $("#loadMoreNews").removeClass("loading");
                  if (newsSize <= n) {
                    $("#loadMoreNews").addClass("disabled");
                    $("#loadMoreNews").text(showText);
                  }
                }, 1200);
              }
            });
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    archive: {
      init: function() {
        $(document).ready(function() {});
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    //**************************************************************************************************
    // Kör script på ALLA sidor.
    //**************************************************************************************************
    common: {
      init: function() {
        //**************************************************************************************************
        // Alla Script
        //**************************************************************************************************
        document.querySelectorAll('.nobox-common-validation').forEach((item) => {
          $(item).validate({
            submitHandler: handleCaptchaValidation,
            errorPlacement: () => false
          });
        })

        $(document).ready(function() {
          var langFix = $("#langPrefixSetup").val();
          if (langFix == "dk") {
            $("#breadcrumbs span span span a:contains('Lediga jobb')").text(
              "Ledige stillinger"
            );
            $("#breadcrumbs span span a:contains('Lediga jobb')").text(
              "Ledige stillinger"
            );
          } else if (langFix == "fi") {
            $("#breadcrumbs span span span a:contains('Lediga jobb')").text(
              "Avoimet työpaikat"
            );
            $("#breadcrumbs span span a:contains('Lediga jobb')").text(
              "Avoimet työpaikat"
            );
          }

          // Kategorimeny | Parent
          // ***************************************************
          if ($(window).width() < 600) {
            var p = $("li.parent-li").length;
            if (p > 2) {
              var true_false = true;
              var items = 2;
            } else {
              var true_false = false;
              var items = 2;
            }
          } else {
            var p = $("li.parent-li").length;
            if (p > 3) {
              var true_false = true;
              var items = 3;
            } else if (p <= 2) {
              var true_false = false;
              var items = 2;
            } else {
              var true_false = false;
              var items = 3;
            }
          }

          $("#categoryMenuParents").owlCarousel({
            loop: false,
            navRewind: false,
            mouseDrag: true_false,
            nav: true_false,
            navText: "",
            smartSpeed: 400,
            dots: false,
            margin: 10,
            items: items,

            responsive: {
              0: {
                items: 2,
              },
              600: {
                items: 2,
              },
              1000: {
                items: items,
              },
            },
          });

          // Navigera slidern till slidern för huvudkategorier.
          var toSlideParent = $(
            "#categoryMenuParents .parent-li.current-parent-category"
          ).attr("data-slideid");
          if (toSlideParent == null) {
            // toSlideParent är tom
            var toSlideParent = 0;
          }
          $("#categoryMenuParents").trigger("to.owl.carousel", [
            toSlideParent,
            0,
            true,
          ]);

          // Kategorimeny | Children
          // ***************************************************
          if ($(window).width() < 600) {
            var c = $("li.child-li").length;
            if (c > 2) {
              var true_false = true;
            } else {
              var true_false = false;
            }
          } else {
            var c = $("li.child-li").length;
            if (c > 4) {
              var true_false = true;
            } else {
              var true_false = false;
            }
          }

          $("#categoryMenuChildren").owlCarousel({
            loop: false,
            navRewind: false,
            mouseDrag: true_false,
            nav: true_false,
            navText: "",
            smartSpeed: 400,
            dots: false,
            margin: 10,
            items: 4,
            responsive: {
              0: {
                items: 2,
              },
              600: {
                items: 2,
              },
              1000: {
                items: 4,
              },
            },
          });

          // Navigera slidern till slidern för underkategorier.
          var toSlideChild = $(
            "#categoryMenuChildren .child-li.current-category"
          ).attr("data-slideid");
          if (toSlideChild == null) {
            // toSlideChild är tom
            var toSlideChild = 0;
          }
          $("#categoryMenuChildren").trigger("to.owl.carousel", [
            toSlideChild,
            0,
            true,
          ]);

          setTimeout(function() {
            $("#categoryMenuParents").removeClass("hidden");
            $("#categoryMenuChildren").removeClass("hidden");
          }, 100);

          // Sticky Formulär

          //SV
          if (
            !$("#" + "emform_273503acc0a3e08a8a7d83e79f8650d5d19308b").length ==
            0
          ) {
            var contactFormId = "273503acc0a3e08a8a7d83e79f8650d5d19308b";
            var contactFieldPrefix = "query_1333039_16";
            var contactMessageFieldId = "1333040";
            var contactCheckboxId = "1333041";

            // //DK - not in use, cause dk site don't uses eemarketer
            // } else if (!$("#" + "emform_273503acc0a3e08a8a7d83e79f8650d5d19308b").length == 0) {
            //     var contactFormId = '273503acc0a3e08a8a7d83e79f8650d5d19308b';
            //     var contactFieldPrefix = 'query_1333039_16';
            //     var contactMessageFieldId = '1333040';
            //     var contactCheckboxId = '1333041';

            //FI
          } else if (
            !$("#" + "emform_273503acc0a3e08a8a7d83e79f8650d5d19308b").length ==
            0
          ) {
            var contactFormId = "269920a1bf298b3612ec81b66d009be18dbe7b6";
            var contactFieldPrefix = "query_1333039_16";
            var contactMessageFieldId = "1333040";
            var contactCheckboxId = "1333041";

            //ENG
          } else if (
            !$("#" + "emform_273503acc0a3e08a8a7d83e79f8650d5d19308b").length ==
            0
          ) {
            var contactFormId = "273503acc0a3e08a8a7d83e79f8650d5d19308b";
            var contactFieldPrefix = "query_1333039_16";
            var contactMessageFieldId = "1333040";
            var contactCheckboxId = "1333041";
          }

          // Set variables for the error message depending on which language the user is viewing the website on
          if (
            $("#emform_273503acc0a3e08a8a7d83e79f8650d5d19308b").hasClass("sv")
          ) {
            var errorCheckMessage = "Du måste acceptera villkoren.";

            // } else if ($( "#emform_273503acc0a3e08a8a7d83e79f8650d5d19308b" ).hasClass( "dk" )) {
            //     var errorCheckMessage = 'Du skal acceptere betingelserne.';
          } else if (
            $("#emform_273503acc0a3e08a8a7d83e79f8650d5d19308b").hasClass("fi")
          ) {
            var errorCheckMessage = "Sinun on hyväksyttävä ehdot.";
          } else if (
            $("#emform_273503acc0a3e08a8a7d83e79f8650d5d19308b").hasClass("eng")
          ) {
            var errorCheckMessage = "You must accept the terms.";
          }

          var rules = {};
          rules[contactFieldPrefix + "_1"] = { required: true };
          rules[contactFieldPrefix + "_2"] = { required: true };
          rules[contactFieldPrefix + "_3"] = { required: true };
          rules[contactFieldPrefix + "_4"] = { required: true };
          rules[contactFieldPrefix + "_5"] = { required: true, email: true };
          rules[contactFieldPrefix + "_6"] = { required: true };
          rules["query_" + contactMessageFieldId + "_5_0_0"] = {
            required: true,
          };
          rules["query_" + contactCheckboxId + "_2_0_0[]"] = { required: true };
          rules["hiddenRecaptcha"] = {
            required: function() {
              if (grecaptcha.getResponse() == "") {
                return true;
              } else {
                return false;
              }
            },
          };

          var messages = {};
          messages[contactFieldPrefix + "_1"] = "";
          messages[contactFieldPrefix + "_2"] = "";
          messages[contactFieldPrefix + "_3"] = "";
          messages[contactFieldPrefix + "_4"] = "";
          messages[contactFieldPrefix + "_5"] = "";
          messages[contactFieldPrefix + "_6"] = "";
          messages["query_" + contactMessageFieldId + "_5_0_0"] = "";
          messages[
            "query_" + contactCheckboxId + "_2_0_0[]"
          ] = errorCheckMessage;
          messages["hiddenRecaptcha"] = "";

          $("form.nobox-form-action-captcha").each(function() {
            var newaction = $(this).data("newaction");
            $(this).attr("action", newaction);
          });

          $("#emform_" + contactFormId).validate({
            // initialize plugin on each form
            ignore: ".ignore",
            rules: rules,
            messages: messages,
            submitHandler: handleCaptchaValidation,
          });

          // !!SLUT!! Sticky Formulär !!SLUT!!

          // Kontaktformulär på varje sida
          var langPrefix = $('input[name="langPrefix"]').val();

          if (langPrefix === "sv") {
            var showText =
              "Tack för att du kontaktar Coromatic. Vi hör av oss snarast möjligt.";
            var showError =
              "Ditt meddelande har inte skickats, något gick fel. Försök igen";

            // } else if(langPrefix === "dk") {
            //     var showText = "Tak for din henvendelse Coromatic. Vi vil kontakte dig så hurtigt som muligt.";
            //     var showError = "Din besked er ikke blevet sendt, noget gik galt. Prøv igen";
          } else if (langPrefix === "fi") {
            var showText =
              "Kiitos että otit yhteyttä! Vastaamme viestiisi mahdollisimman pian.";
            var showError =
              "Viestisi ei ole lähetetty, jotain meni pieleen. yritä uudelleen";
          } else if (langPrefix === "en") {
            var showText =
              "Thank you for contacting Coromatic. We will contact us as soon as possible.";
            var showError =
              "Your message has not been sent, something went wrong. Try again";
          }

          if (
            !$("#" + "emform_269921aee01abcf7f80db959a5f97ce30c718ab").length ==
            0
          ) {
            // var contactFormId = "269921aee01abcf7f80db959a5f97ce30c718ab";
            var contactFieldPrefix = "query_1301559_16";
            var contactMessageFieldId = "1301560";
            var contactCheckboxId = "1302447";
            var errorCheckMessage = "Du måste acceptera villkoren.";

            // } else if (!$("#" + "emform_270032a0a748b2c6a9d0c66b5a4a81897c571e3").length == 0) {
            //     var contactFormId = '270032a0a748b2c6a9d0c66b5a4a81897c571e3';
            //     var contactFieldPrefix = 'query_1302582_16';
            //     var contactMessageFieldId = '1302583';
            //     var contactCheckboxId = '1302585';
            //     var errorCheckMessage = 'Du skal acceptere betingelserne.';
          } else if (
            !$("#" + "emform_269920a1bf298b3612ec81b66d009be18dbe7b6").length ==
            0
          ) {
            var contactFormId = "269920a1bf298b3612ec81b66d009be18dbe7b6";
            var contactFieldPrefix = "query_1301553_16";
            var contactMessageFieldId = "1301554";
            var contactCheckboxId = "1302423";
            var errorCheckMessage = "Sinun on hyväksyttävä ehdot.";
          } else if (
            !$("#" + "emform_269221a27b8017e0e2a42330cb057221926995e").length ==
            0
          ) {
            // var contactFormId = "269221a27b8017e0e2a42330cb057221926995e";
            var contactFieldPrefix = "query_1295590_16";
            var contactMessageFieldId = "1295630";
            var contactCheckboxId = "1302422";
            var errorCheckMessage = "You must accept the terms.";
          }

          var rules = {};
          rules[contactFieldPrefix + "_1"] = { required: true };
          rules[contactFieldPrefix + "_2"] = { required: true };
          rules[contactFieldPrefix + "_3"] = { required: true };
          rules[contactFieldPrefix + "_4"] = { required: true };
          rules[contactFieldPrefix + "_5"] = { required: true, email: true };
          rules[contactFieldPrefix + "_6"] = { required: true };
          rules["query_" + contactMessageFieldId + "_5_0_0"] = {
            required: true,
          };
          rules["query_" + contactCheckboxId + "_2_0_0[]"] = { required: true };
          rules["hiddenRecaptcha"] = {
            required: function() {
              if (grecaptcha.getResponse() == "") {
                return true;
              } else {
                return false;
              }
            },
          };

          var messages = {};
          messages[contactFieldPrefix + "_1"] = "";
          messages[contactFieldPrefix + "_2"] = "";
          messages[contactFieldPrefix + "_3"] = "";
          messages[contactFieldPrefix + "_4"] = "";
          messages[contactFieldPrefix + "_5"] = "";
          messages[contactFieldPrefix + "_6"] = "";
          messages["query_" + contactMessageFieldId + "_5_0_0"] = "";
          messages[
            "query_" + contactCheckboxId + "_2_0_0[]"
          ] = errorCheckMessage;
          messages["hiddenRecaptcha"] = "";

          // console.log([contactFormId, contactFieldPrefix, contactMessageFieldId, contactCheckboxId]);
          // console.log([rules, messages]);

          $("#emform_" + contactFormId).validate({
            // initialize plugin on each form
            ignore: ".ignore",
            rules: rules,
            messages: messages,
            submitHandler: handleCaptchaValidation,
          });


          // Visa / Dölj info i karta
          //**************************************************************************************************
          $(".mark").click(function() {
            var markID = $(this).attr("data-mark");
            $(".markAdress").fadeOut();

            if ($("[data-info=" + markID + "]").is(":hidden")) {
              $("[data-info=" + markID + "]").fadeIn(200);
            } else {
              $("[data-info=" + markID + "]").fadeOut(200);
            }
          });

          // Markera sökordet
          //*********************************************************************
          var term_result = $("#search_term_result").val();

          // Om skärmen är mindre än 568
          if ($(window).width() < 568) {
            // Scrolla till toppen
            //**********************************************************************************************
            $("#slideToTop").click(function() {
              $("html, body").animate({ scrollTop: 0 }, 600);
              return false;
            });
            $(window).scroll(function() {
              if ($(this).scrollTop() > 400) {
                $("#slideToTop").fadeIn(400);
              } else {
                $("#slideToTop").fadeOut(400);
              }
            });
          }

          // Scrolla till sektion (Download)
          //**********************************************************************************************
          var scrollTo = $("#scrollTo").val();
          if (scrollTo) {
            var scrollTo = "#item_" + scrollTo;
            var addClassTo = scrollTo + " .downloadForm";

            // Handler for .ready() called.
            $("html, body").animate(
              {
                scrollTop: $(scrollTo).offset().top - 150,
              },
              400
            );
          }

          // Formulär på alla sidor under Ladda ner - Samt tillbehör
          //**********************************************************************************************
          $(".downloadShowForm").click(function() {
            var formID = $(this).attr("data-button");
            $(".downloadForm").slideUp();

            if ($("[data-form=" + formID + "]").is(":hidden")) {
              $("[data-form=" + formID + "]").slideDown(300);
            } else {
              $("[data-form=" + formID + "]").slideUp(300);
            }
          });

          //Om skärmen är Mindre eller lika med 961px
          if ($(window).width() < 667) {
            $("#frontpageTaglineTitles").insertBefore("#newsSection");
          }

          // Hela ladda ner sektionen med Case, Whitepaper, Broschyrer, produktblad
          var langPrefix = $("#langPrefix").val();
          if (langPrefix === "sv") {
            var showText = "Inget mer att visa";
          } else if (langPrefix === "no") {
            var showText = "Ingenting mer å vise";
          } else if (langPrefix === "dk") {
            var showText = "Intet mere at vise";
          } else if (langPrefix === "fi") {
            var showText = "NÄYTETTÄVÄ MATERIAALI LOPPUI";
          } else if (langPrefix === "en") {
            var showText = "Nothing more to show";
          }

          // LADDA NER dokument under sidan LADDA NER
          $("input.hiddenID").each(function() {
            var elementID = $(this).val();
            var readmoreButton = $(
              '.readmoreButton[data-morebutton="' + elementID + '"]'
            );
            var elementItem = $(
              ".downloadRowContent .downloadItem_" + elementID
            ).size(); // Hämta alla element

            i = 3;
            $(
              ".downloadRowContent .downloadItem_" +
                elementID +
                ":lt(" +
                i +
                ")"
            ).show(); // Visa antalet element baserat på vaibabeln $i

            $(".showMoreDownload").click(function() {
              var id = $(this).attr("data-morebutton");
              var elementItem = $(
                ".downloadRowContent .downloadItem_" + id
              ).size(); // Hämta alla element

              if (elementItem == i) {
                $('.showMoreDownload[data-morebutton="' + id + '"]').addClass(
                  "disabled"
                );
                $('.showMoreDownload[data-morebutton="' + id + '"]').text(
                  showText
                );
              } else {
                $('.showMoreDownload[data-morebutton="' + id + '"]').addClass(
                  "loading"
                );
                setTimeout(function() {
                  i = i + 5 <= elementItem ? i + 5 : elementItem;
                  $(
                    '.downloadItemPage[data-elementshow="' +
                      id +
                      '"]:lt(' +
                      i +
                      ")"
                  ).show();
                  $(
                    '.showMoreDownload[data-morebutton="' + id + '"]'
                  ).removeClass("loading");
                  if (elementItem <= i) {
                    $(
                      '.showMoreDownload[data-morebutton="' + id + '"]'
                    ).addClass("disabled");
                    $('.showMoreDownload[data-morebutton="' + id + '"]').text(
                      showText
                    );
                  }
                }, 1200);
              }
            });
          });

          //Om skärmen är mindre eller lika med liggande iphone 6 plus
          if ($(window).width() <= 960) {
            // Toggle sökfunktion och språk
            $("#mobileLangToggle").click(function () {
              $("#toggle_navigation").removeClass("open");
              $("#mobileSearchToggle").removeClass("active");
              $(this).toggleClass("active");
              $("span.grow_mobile").removeClass("active");

              $(".sub-menu-wrap").slideUp("fast");
              $("#mobileOptionsToggle #searchBox").slideUp(300);
              $("#main_navigation").slideUp(300);
              $("#mobileOptionsToggle #langNav").slideToggle(300);
            });
            $("#mobileSearchToggle").click(function () {
              $("#mobileLangToggle").removeClass("active");
              $("#toggle_navigation").removeClass("open");
              $(this).toggleClass("active");
              $("span.grow_mobile").removeClass("active");

              $(".sub-menu-wrap").slideUp("fast");
              $("#mobileOptionsToggle #langNav").slideUp(300);
              $("#main_navigation").slideUp(300);
              $("#mobileOptionsToggle #searchBox").slideToggle(300);
            });

            // Toggla navigationen
            $("#toggle_navigation").click(function() {
              $(this).toggleClass("open");
              $("#mobileLangToggle").removeClass("active");
              $("#mobileSearchToggle ").removeClass("active");
              $("span.grow_mobile").removeClass("active");

              $(".sub-menu-wrap").slideUp("fast");
              $("#mobileOptionsToggle #searchBox").slideUp(300);
              $("#mobileOptionsToggle #langNav").slideUp(300);
              $("#main_navigation").slideToggle(400);
            });

            //Lägg till knappen GROW för togglefunktion
            //****************************************************
            $(
              '<span class="grow_mobile"><i class="fa fa-plus-circle" aria-hidden="true"></i></span>'
            ).insertAfter(".nav li.menu-item-has-children > a");
            $("li.menu-item-has-children span.grow_mobile").click(function() {
              $(this).toggleClass("active");
              $(this)
                .parent()
                .children(".sub-menu-wrap")
                .slideToggle("fast");
              console.log("click7");
            });
          }

          //Om skärmen är Större eller lika med 961px
          if ($(window).width() > 961) {
            $(".sprak").click(function() {
              $(".fa-search-toggle").removeClass("active");
              $(".serachHidden").slideUp(200);

              $(this).toggleClass("active");
              $(".langNav").slideToggle(200);
            });

            // Toggle sökfunktion och språk
            $(".fa-search-toggle").click(function() {
              $(".sprak").removeClass("active");
              $(".langNav").slideUp(200);
              $(this).toggleClass("active");
              $(".serachHidden").slideToggle(200);
            });

            $(".customMenuInfo")
              .appendTo(
                ".nav > .nav_container > li.menu-item-has-children > .sub-menu-wrap"
              )
              .addClass("vissible");
            // Visa dölj menyn (SlideToggle)
            //**********************************************************************************************
            var currentItem;

            $(".nav .nav_container > li.menu-item-has-children").hover(
              function() {
                var currentItem = $(this);
                $(this)
                  .children()
                  .addClass("active");
                heightFix(currentItem);
              },
              function() {
                heightFixRemove();

                $(".sub-menu-wrap").removeClass("open");
                $(this)
                  .children()
                  .removeClass("active");
                $("a").removeClass("open");
                $("span.grow_level_1").removeClass("active open");
                $("span.grow_level_2").removeClass("active open");
                $("span.grow_level_3").removeClass("active open");
                $(".sub-menu-wrap").removeClass("open");
              }
            );

            function heightFix(currentItem) {
              // console.log(currentItem[0].id);
              var selector = "#" + currentItem[0].id;
              var highestBox = 0;
              $(selector + " .sub-menu").each(function() {
                if ($(this).height() > highestBox) {
                  highestBox = $(this).height();
                  // console.log(highestBox);
                  if (highestBox < 270) {
                    highestBox = highestBox; /*285;*/
                  } else {
                    highestBox = highestBox; /*highestBox+40;*/
                  }
                }
                // console.log(highestBox);
              });

              $(
                ".nav > .nav_container li.menu-item-has-children > .sub-menu-wrap"
              ).css("min-height", highestBox);
            }

            function heightFixRemove() {
              $(
                ".nav > .nav_container li.menu-item-has-children > .sub-menu-wrap"
              ).css("min-height", "0");
            }

            // Lägg till span.grow på undermenyer för lättare toggle.
            //**********************************************************************************************
            $(
              '<span class="grow_level_1"><i class="fa fa-plus-circle" aria-hidden="true"></i></span>'
            ).insertAfter(".nav_container ul li.menu-item-has-children  > a");
            $(
              ".nav_container ul li.menu-item-has-children > span.grow_level_1"
            ).click(function() {
              if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this)
                  .parent()
                  .children()
                  .removeClass("open");
              } else {
                $(".nav_container ul li.menu-item-has-children a").removeClass(
                  "open"
                );
                $(
                  ".nav_container ul li.menu-item-has-children span.grow_level_1"
                ).removeClass("active open");
                $(
                  ".nav_container ul li.menu-item-has-children ul li.menu-item-has-children span.grow_level_2"
                ).removeClass("active open");
                $(
                  ".nav_container ul li.menu-item-has-children .sub-menu-wrap"
                ).removeClass("open");
                $(this)
                  .parent()
                  .children()
                  .addClass("open");
                $(this).addClass("active");
              }
            });

            $(
              '<span class="grow_level_2"><i class="fa fa-plus-circle" aria-hidden="true"></i></span>'
            ).insertAfter(
              ".nav_container ul li.menu-item-has-children ul li.menu-item-has-children > a"
            );
            $(
              ".nav_container ul li.menu-item-has-children ul li.menu-item-has-children > span.grow_level_2"
            ).click(function() {
              if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this)
                  .parent()
                  .children()
                  .removeClass("open");
              } else {
                $(
                  ".nav_container ul li.menu-item-has-children ul li.menu-item-has-children a"
                ).removeClass("open");
                $(
                  ".nav_container ul li.menu-item-has-children ul li.menu-item-has-children span.grow_level_2"
                ).removeClass("active open");
                $(
                  ".nav_container ul li.menu-item-has-children ul li.menu-item-has-children .sub-menu-wrap"
                ).removeClass("open");
                $(this)
                  .parent()
                  .children()
                  .addClass("open");
                $(this).addClass("active");
              }
            });

            $(
              '<span class="grow_level_3"><i class="fa fa-plus-circle" aria-hidden="true"></i></span>'
            ).insertAfter(
              ".nav_container ul li.menu-item-has-children ul li.menu-item-has-children ul li.menu-item-has-children > a"
            );
            $(
              ".nav_container ul li.menu-item-has-children ul li.menu-item-has-children ul li.menu-item-has-children > span.grow_level_3"
            ).click(function() {
              if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this)
                  .parent()
                  .children()
                  .removeClass("open");
              } else {
                $(
                  ".nav_container ul li.menu-item-has-children ul li.menu-item-has-children ul li.menu-item-has-children a"
                ).removeClass("open");
                $(
                  ".nav_container ul li.menu-item-has-children ul li.menu-item-has-children ul li.menu-item-has-children span.grow_level_3"
                ).removeClass("active open");
                $(
                  ".nav_container ul li.menu-item-has-children ul li.menu-item-has-children ul li.menu-item-has-children .sub-menu-wrap"
                ).removeClass("open");
                $(this)
                  .parent()
                  .children()
                  .addClass("open");
                $(this).addClass("active");
              }
            });

            // Lägg på classer på meny för att docka den vid scroll.
            //**********************************************************************************************
            $(window).scroll(function() {
              if ($(this).scrollTop() > 130) {
                $("#header").addClass("fixed");
                $(".wrapper_header").addClass("fixed");
              } else {
                $("#header").removeClass("fixed");
                $(".wrapper_header").removeClass("fixed");
              }
            });
          }

          // Formulär ikoner
          //***********************
          $(
            ".row input.requiredField, .row select.requiredField, .row textarea.requiredField"
          ).blur(function() {
            var $this = $(this);
            var parent = $this.parent();
            if (
              $(this)
                .val()
                .trim().length != 0
            ) {
              $this.addClass("valid");
              $this.removeClass("error");
            } else {
              $this.addClass("error");
              $this.removeClass("valid");
            }
          });

          // Ta bort data-src när bilden är laddad.
          //**********************************************************************************************
          [].forEach.call(document.querySelectorAll("img[data-src]"), function(
            img
          ) {
            img.setAttribute("src", img.getAttribute("data-src"));
            img.onload = function() {
              img.removeAttribute("data-src");
            };
          });

          // Spåra Utklick (GA)
          //**********************************************************************************************
          function _gaLt(event) {
            var el = event.srcElement || event.target;
            while (
              el &&
              (typeof el.tagName == "undefined" ||
                el.tagName.toLowerCase() != "a" ||
                !el.href)
            ) {
              el = el.parentNode;
            }
            if (el && el.href) {
              var link = el.href;
              if (
                link.indexOf(location.host) == -1 &&
                !link.match(/^javascript\:/i)
              ) {
                var hitBack = function(link, target) {
                  target
                    ? window.open(link, target)
                    : (window.location.href = link);
                };
                var target =
                  el.target && !el.target.match(/^_(self|parent|top)$/i)
                    ? el.target
                    : false;
                ga(
                  "send",
                  "event",
                  "Outgoing Links",
                  link,
                  document.location.pathname + document.location.search,
                  { hitCallback: hitBack(link, target) }
                );
                event.preventDefault
                  ? event.preventDefault()
                  : (event.returnValue = !1);
              }
            }
          }
          var w = window;
          w.addEventListener
            ? w.addEventListener(
                "load",
                function() {
                  document.body.addEventListener("click", _gaLt, !1);
                },
                !1
              )
            : w.attachEvent &&
              w.attachEvent("onload", function() {
                document.body.attachEvent("onclick", _gaLt);
              });
        }); //End of $(document).ready(function()
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
